// extracted by mini-css-extract-plugin
module.exports = {"customSlideOptionsContainer":"CustomCampainCreatePage_customSlideOptionsContainer__2YV9o"};